export const PROJECT_TITLE = 'Sett Solutions'

export const FREEZE_CLIENT_MSG = 'Your account is currently frozen. Please contact the administrator to unfreeze it.'

export const ICAL_MSG = 'Please note that you need to add a payment method to enable ICal link integration.'

export const SIDEBAR_MENU = [
  // {
  //   "path": "/",
  //   "title": "Dashboard",
  //   "icon": "dashboard"  // Example icon name
  // },
  {
    path: '/schedules',
    title: 'Schedules',
    icon: 'calendar' // Example icon name
  },
  {
    path: '/properties',
    title: 'Properties',
    icon: 'map-pin' // Example icon name
  },
  {
    path: '/reviews',
    title: 'Reviews',
    icon: 'star' // Example icon name
  },
  {
    path: '/notifications',
    title: 'Notifications',
    icon: 'bell' // Example icon name
  },
  {
    path: '/billings',
    title: 'Billings',
    icon: 'credit-card' // Example icon name
  }
]

export const CALENDAR_EVENT = [
  {
    title: 'LOFT 317',
    date: '2024-07-01',
    host_name: 'John Deo',
    cleaner_name: 'Alexandra Bond',
    accepted: false,
    checkout: '2024-07-01T10:30:00',
    next_check_in: '2024-07-01T11:30:00',
    status: 'done',
    color: '#73D671'
  },
  {
    title: 'FONT 2BED',
    date: '2024-07-01',
    host_name: 'Charles Cornish',
    cleaner_name: 'Boris Hardacre',
    accepted: false,
    checkout: '2024-07-01T08:30:00',
    next_check_in: '2024-07-01T09:30:00',
    status: 'done',
    color: '#73D671'
  },
  {
    title: '87 CASTELLINA',
    date: '2024-07-02',
    host_name: 'Sophie McDonald',
    cleaner_name: 'Michael Lee',
    accepted: true,
    checkout: '2024-07-02T10:30:00',
    next_check_in: '2024-07-02T11:30:00',
    status: 'Schedule',
    color: '#589FBC'
  }
]

export const ADMIN_CONTROL = [
  {
    id: 1,
    first_name: 'John',
    last_name: 'Doe',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Ahmedabad, Gujarat, India',
    status: 'Active',
    profile: 'profile_url_1' // Replace with actual profile URL
  },
  {
    id: 2,
    first_name: 'Jane',
    last_name: 'Doe',
    email: 'example@gmail.com',
    admin_type: 'admin',
    region: 'Mumbai, Maharashtra, India',
    status: 'Active',
    profile: 'profile_url_2' // Replace with actual profile URL
  },
  {
    id: 3,
    first_name: 'Mike',
    last_name: 'Wilson',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Delhi, Delhi NCR, India',
    status: 'Inactive',
    profile: 'profile_url_3' // Replace with actual profile URL
  },
  {
    id: 4,
    first_name: 'Alice',
    last_name: 'Johnson',
    email: 'example@gmail.com',
    admin_type: 'super admin',
    region: 'Bangalore, Karnataka, India',
    status: 'Active',
    profile: 'profile_url_4' // Replace with actual profile URL
  },
  {
    id: 5,
    first_name: 'David',
    last_name: 'Miller',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Chennai, Tamil Nadu, India',
    status: 'Active',
    profile: 'profile_url_5' // Replace with actual profile URL
  },
  {
    id: 6,
    first_name: 'Sarah',
    last_name: 'Williams',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Hyderabad, Telangana, India',
    status: 'Inactive',
    profile: 'profile_url_6' // Replace with actual profile URL
  },
  {
    id: 7,
    first_name: 'William',
    last_name: 'Brown',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Kolkata, West Bengal, India',
    status: 'Active',
    profile: 'profile_url_7' // Replace with actual profile URL
  },
  {
    id: 8,
    first_name: 'Jennifer',
    last_name: 'Jones',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Pune, Maharashtra, India',
    status: 'Active',
    profile: 'profile_url_8' // Replace with actual profile URL
  },
  {
    id: 9,
    first_name: 'Matthew',
    last_name: 'Davis',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Jaipur, Rajasthan, India',
    status: 'Inactive',
    profile: 'profile_url_9' // Replace with actual profile URL
  },
  {
    id: 10,
    first_name: 'Elizabeth',
    last_name: 'Garcia',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    region: 'Surat, Gujarat, India',
    status: 'Active',
    profile: 'profile_url_10' // Replace with actual profile URL
  },
  {
    id: 11,
    first_name: 'Kevin',
    last_name: 'Johnson',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    status: 'Active',
    region: 'Bharuch, Gujarat, India',
    profile: 'user_avatar.gif'
  },
  {
    id: 12,
    first_name: 'Elizabeth',
    last_name: 'Lewis',
    email: 'example@gmail.com',
    admin_type: 'manager admin',
    status: 'Active',
    region: 'Tapi, Gujarat, India',
    profile: 'default_icon.jpg'
  }
]

export const CLIENTS = [
  {
    id: 1,
    profile: 'Host',
    first_name: 'John',
    last_name: 'Doe',
    email: 'john.doe@example.com',
    phone: '+1234567890',
    total_properties: 3,
    total_cleanings: 50,
    total_strikes: 1,
    rating_score: 4.8
  },
  {
    id: 2,
    profile: 'Guest',
    first_name: 'Jane',
    last_name: 'Smith',
    email: 'jane.smith@example.com',
    phone: '+0987654321',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.9
  },
  {
    id: 3,
    profile: 'Host',
    first_name: 'Emily',
    last_name: 'Brown',
    email: 'emily.brown@example.com',
    phone: '+1122334455',
    total_properties: 5,
    total_cleanings: 75,
    total_strikes: 2,
    rating_score: 4.7
  },
  {
    id: 4,
    profile: 'Guest',
    first_name: 'Michael',
    last_name: 'Johnson',
    email: 'michael.johnson@example.com',
    phone: '+2233445566',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.6
  },
  {
    id: 5,
    profile: 'Host',
    first_name: 'Sarah',
    last_name: 'Davis',
    email: 'sarah.davis@example.com',
    phone: '+3344556677',
    total_properties: 2,
    total_cleanings: 30,
    total_strikes: 1,
    rating_score: 4.9
  },
  {
    id: 6,
    profile: 'Guest',
    first_name: 'David',
    last_name: 'Miller',
    email: 'david.miller@example.com',
    phone: '+4455667788',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.8
  },
  {
    id: 7,
    profile: 'Host',
    first_name: 'Laura',
    last_name: 'Wilson',
    email: 'laura.wilson@example.com',
    phone: '+5566778899',
    total_properties: 4,
    total_cleanings: 60,
    total_strikes: 1,
    rating_score: 4.6
  },
  {
    id: 8,
    profile: 'Guest',
    first_name: 'Robert',
    last_name: 'Moore',
    email: 'robert.moore@example.com',
    phone: '+6677889900',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.5
  },
  {
    id: 9,
    profile: 'Host',
    first_name: 'Jessica',
    last_name: 'Taylor',
    email: 'jessica.taylor@example.com',
    phone: '+7788990011',
    total_properties: 6,
    total_cleanings: 90,
    total_strikes: 3,
    rating_score: 4.4
  },
  {
    id: 10,
    profile: 'Guest',
    first_name: 'Thomas',
    last_name: 'Anderson',
    email: 'thomas.anderson@example.com',
    phone: '+8899001122',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.7
  },
  {
    id: 11,
    profile: 'Host',
    first_name: 'Ashley',
    last_name: 'Martinez',
    email: 'ashley.martinez@example.com',
    phone: '+9900112233',
    total_properties: 3,
    total_cleanings: 45,
    total_strikes: 2,
    rating_score: 4.5
  },
  {
    id: 12,
    profile: 'Guest',
    first_name: 'Brian',
    last_name: 'Garcia',
    email: 'brian.garcia@example.com',
    phone: '+1011121314',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.8
  },
  {
    id: 13,
    profile: 'Host',
    first_name: 'Samantha',
    last_name: 'Rodriguez',
    email: 'samantha.rodriguez@example.com',
    phone: '+2021222324',
    total_properties: 1,
    total_cleanings: 20,
    total_strikes: 0,
    rating_score: 4.9
  },
  {
    id: 14,
    profile: 'Guest',
    first_name: 'Kevin',
    last_name: 'Hernandez',
    email: 'kevin.hernandez@example.com',
    phone: '+3031323334',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.7
  },
  {
    id: 15,
    profile: 'Host',
    first_name: 'Amy',
    last_name: 'Martinez',
    email: 'amy.martinez@example.com',
    phone: '+4041424344',
    total_properties: 2,
    total_cleanings: 35,
    total_strikes: 1,
    rating_score: 4.8
  },
  {
    id: 16,
    profile: 'Guest',
    first_name: 'James',
    last_name: 'Lopez',
    email: 'james.lopez@example.com',
    phone: '+5051525354',
    total_properties: 0,
    total_cleanings: 0,
    total_strikes: 0,
    rating_score: 4.6
  }
]

export const PROPERTIES = [
  {
    properties_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    client_id: 'f7e8d9c0-b1a2-3c4d-5e6f-7g8h9i0j1k2l',
    number_of_rooms: 3,
    number_of_bathroom: 2,
    sequre_foot: '1500 sqft',
    other: 'Pool, Garage',
    property_name: 'Cozy Cottage',
    zipcode: '12345',
    address: '123 Maple St',
    state: 'NY',
    city: 'Albany',
    location_latt: '42.6526',
    location_long: '-73.7562',
    get_in: 'Keybox',
    get_in_instruction: 'Keybox is located at the front door.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/cozycottage.ics',
      ical_label: 'Cozy Cottage Calendar'
    },
    property_image: 'http://example.com/images/cozycottage.jpg',
    airbnb_listing_id: '12345678',
    airbnb_bedrooms: 3,
    airbnb_bathrooms: 2,
    main_cleaner: 'Rachel	Parsons',
    total_value: 135.0,
    cleaner_service_value: 90.0,
    is_active: true,
    is_deleted: false,
    created_by: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    updated_by: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    deleted_by: null,
    created_at: '1622548800',
    updated_at: '1622635200',
    deleted_at: null
  },
  {
    properties_id: 'b2c3d4e5-f6g7-h8i9-0j1k-l2m3n4o5p6q7',
    client_id: 'g8h9i0j1-k2l3-m4n5-o6p7-q8r9s0t1u2v3',
    number_of_rooms: 4,
    number_of_bathroom: 3,
    sequre_foot: '2000 sqft',
    other: 'Garden, Fireplace',
    property_name: 'Modern Villa',
    zipcode: '67890',
    address: '456 Oak St',
    state: 'CA',
    city: 'Los Angeles',
    location_latt: '34.0522',
    location_long: '-118.2437',
    get_in: 'Smart Lock',
    get_in_instruction: 'Enter the code on the smart lock.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/modernvilla.ics',
      ical_label: 'Modern Villa Calendar'
    },
    property_image: 'http://example.com/images/modernvilla.jpg',
    airbnb_listing_id: '87654321',
    airbnb_bedrooms: 4,
    airbnb_bathrooms: 3,
    main_cleaner: 'Dorothy Coleman',
    total_value: 87.0,
    cleaner_service_value: 121.0,
    is_active: true,
    is_deleted: false,
    created_by: 'b2c3d4e5-f6g7-h8i9-0j1k-l2m3n4o5p6q7',
    updated_by: 'b2c3d4e5-f6g7-h8i9-0j1k-l2m3n4o5p6q7',
    deleted_by: null,
    created_at: '1622635200',
    updated_at: '1622721600',
    deleted_at: null
  },
  {
    properties_id: 'c3d4e5f6-g7h8-i9j0-k1l2-m3n4o5p6q7r8',
    client_id: 'h9i0j1k2-l3m4-n5o6-p7q8-r9s0t1u2v3w4',
    number_of_rooms: 2,
    number_of_bathroom: 1,
    sequre_foot: '1000 sqft',
    other: 'Balcony, Central Heating',
    property_name: 'City Apartment',
    zipcode: '54321',
    address: '789 Pine St',
    state: 'IL',
    city: 'Chicago',
    location_latt: '41.8781',
    location_long: '-87.6298',
    get_in: 'Doorman',
    get_in_instruction: 'Check in with the doorman.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/cityapartment.ics',
      ical_label: 'City Apartment Calendar'
    },
    property_image: 'http://example.com/images/cityapartment.jpg',
    airbnb_listing_id: '23456789',
    airbnb_bedrooms: 2,
    airbnb_bathrooms: 1,
    main_cleaner: 'Gavin Knox',
    total_value: 43.0,
    cleaner_service_value: 78.0,
    is_active: true,
    is_deleted: false,
    created_by: 'c3d4e5f6-g7h8-i9j0-k1l2-m3n4o5p6q7r8',
    updated_by: 'c3d4e5f6-g7h8-i9j0-k1l2-m3n4o5p6q7r8',
    deleted_by: null,
    created_at: '1622721600',
    updated_at: '1622808000',
    deleted_at: null
  },
  {
    properties_id: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    client_id: 'i0j1k2l3-m4n5-o6p7-q8r9-s0t1u2v3w4x5',
    number_of_rooms: 5,
    number_of_bathroom: 4,
    sequre_foot: '2500 sqft',
    other: 'Gym, Sauna',
    property_name: 'Luxury Penthouse',
    zipcode: '98765',
    address: '101 Elm St',
    state: 'TX',
    city: 'Dallas',
    location_latt: '32.7767',
    location_long: '-96.7970',
    get_in: 'Keycode',
    get_in_instruction: 'Enter the keycode on the keypad.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/luxurypenthouse.ics',
      ical_label: 'Luxury Penthouse Calendar'
    },
    property_image: 'http://example.com/images/luxurypenthouse.jpg',
    airbnb_listing_id: '34567890',
    airbnb_bedrooms: 5,
    airbnb_bathrooms: 4,
    main_cleaner: 'Boris Cornish',
    total_value: 77.0,
    cleaner_service_value: 119.0,
    is_active: true,
    is_deleted: false,
    created_by: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    updated_by: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    deleted_by: null,
    created_at: '1622808000',
    updated_at: '1622894400',
    deleted_at: null
  },
  {
    properties_id: 'e5f6g7h8-i9j0-k1l2-m3n4-o5p6q7r8s9t0',
    client_id: 'j1k2l3m4-n5o6-p7q8-r9s0-t1u2v3w4x5y6',
    number_of_rooms: 3,
    number_of_bathroom: 2,
    sequre_foot: '1700 sqft',
    other: 'Home Theater, BBQ Area',
    property_name: 'Family Home',
    zipcode: '23456',
    address: '202 Birch St',
    state: 'FL',
    city: 'Miami',
    location_latt: '25.7617',
    location_long: '-80.1918',
    get_in: 'Lockbox',
    get_in_instruction: 'Lockbox is near the garage.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/familyhome.ics',
      ical_label: 'Family Home Calendar'
    },
    property_image: 'http://example.com/images/familyhome.jpg',
    airbnb_listing_id: '45678901',
    airbnb_bedrooms: 3,
    airbnb_bathrooms: 2,
    main_cleaner: 'Alan King',
    total_value: 14.0,
    cleaner_service_value: 55.0,
    is_active: true,
    is_deleted: false,
    created_by: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    updated_by: 'd4e5f6g7-h8i9-j0k1-l2m3-n4o5p6q7r8s9',
    deleted_by: null,
    created_at: '1622808000',
    updated_at: '1622894400',
    deleted_at: null
  },
  {
    properties_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    client_id: 'f7e8d9c0-b1a2-3c4d-5e6f-7g8h9i0j1k2l',
    number_of_rooms: 3,
    number_of_bathroom: 2,
    sequre_foot: '1500 sqft',
    other: 'Pool, Garage',
    property_name: 'Cozy Cottage',
    zipcode: '12345',
    address: '123 Maple St',
    state: 'NY',
    city: 'Albany',
    location_latt: '42.6526',
    location_long: '-73.7562',
    get_in: 'Keybox',
    get_in_instruction: 'Keybox is located at the front door.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/cozycottage.ics',
      ical_label: 'Cozy Cottage Calendar'
    },
    property_image: 'http://example.com/images/cozycottage.jpg',
    airbnb_listing_id: '12345678',
    airbnb_bedrooms: 3,
    airbnb_bathrooms: 2,
    main_cleaner: 'Rachel Parsons',
    total_value: 135.0,
    cleaner_service_value: 90.0,
    is_active: true,
    is_deleted: false,
    created_by: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    updated_by: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
    deleted_by: null,
    created_at: '1622548800',
    updated_at: '1622635200',
    deleted_at: null
  },
  {
    properties_id: 'b2c3d4e5-f6g7-8h9i-0j1k-2l3m4n5o6p7q',
    client_id: 'g8h9i0j1-k2l3-4m5n-6o7p-8q9r0s1t2u3v',
    number_of_rooms: 4,
    number_of_bathroom: 3,
    sequre_foot: '2000 sqft',
    other: 'Garden, Garage',
    property_name: 'Spacious Villa',
    zipcode: '54321',
    address: '456 Oak St',
    state: 'CA',
    city: 'Los Angeles',
    location_latt: '34.0522',
    location_long: '-118.2437',
    get_in: 'Keybox',
    get_in_instruction: 'Keybox is located at the back door.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/spaciousvilla.ics',
      ical_label: 'Spacious Villa Calendar'
    },
    property_image: 'http://example.com/images/spaciousvilla.jpg',
    airbnb_listing_id: '87654321',
    airbnb_bedrooms: 4,
    airbnb_bathrooms: 3,
    main_cleaner: 'Monica Geller',
    total_value: 250.0,
    cleaner_service_value: 150.0,
    is_active: true,
    is_deleted: false,
    created_by: 'b2c3d4e5-f6g7-8h9i-0j1k-2l3m4n5o6p7q',
    updated_by: 'b2c3d4e5-f6g7-8h9i-0j1k-2l3m4n5o6p7q',
    deleted_by: null,
    created_at: '1622635200',
    updated_at: '1622721600',
    deleted_at: null
  },
  {
    properties_id: 'c3d4e5f6-g7h8-9i0j-1k2l-3m4n5o6p7q8r',
    client_id: 'h9i0j1k2-l3m4-5n6o-7p8q-9r0s1t2u3v4w',
    number_of_rooms: 2,
    number_of_bathroom: 1,
    sequre_foot: '1000 sqft',
    other: 'Balcony',
    property_name: 'Modern Apartment',
    zipcode: '67890',
    address: '789 Pine St',
    state: 'IL',
    city: 'Chicago',
    location_latt: '41.8781',
    location_long: '-87.6298',
    get_in: 'Keybox',
    get_in_instruction: 'Keybox is located at the lobby.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/modernapartment.ics',
      ical_label: 'Modern Apartment Calendar'
    },
    property_image: 'http://example.com/images/modernapartment.jpg',
    airbnb_listing_id: '11223344',
    airbnb_bedrooms: 2,
    airbnb_bathrooms: 1,
    main_cleaner: 'Phoebe Buffay',
    total_value: 100.0,
    cleaner_service_value: 60.0,
    is_active: true,
    is_deleted: false,
    created_by: 'c3d4e5f6-g7h8-9i0j-1k2l-3m4n5o6p7q8r',
    updated_by: 'c3d4e5f6-g7h8-9i0j-1k2l-3m4n5o6p7q8r',
    deleted_by: null,
    created_at: '1622721600',
    updated_at: '1622808000',
    deleted_at: null
  },
  {
    properties_id: 'd4e5f6g7-h8i9-0j1k-2l3m-4n5o6p7q8r9s',
    client_id: 'i0j1k2l3-m4n5-6o7p-8q9r-0s1t2u3v4w5x',
    number_of_rooms: 5,
    number_of_bathroom: 4,
    sequre_foot: '3000 sqft',
    other: 'Pool, Garden, Garage',
    property_name: 'Luxury Mansion',
    zipcode: '98765',
    address: '101 Maple St',
    state: 'TX',
    city: 'Houston',
    location_latt: '29.7604',
    location_long: '-95.3698',
    get_in: 'Keybox',
    get_in_instruction: 'Keybox is located at the gate.',
    propertyICalLink: {
      ical_link: 'http://example.com/ical/luxurymansion.ics',
      ical_label: 'Luxury Mansion Calendar'
    },
    property_image: 'http://example.com/images/luxurymansion.jpg',
    airbnb_listing_id: '55667788',
    airbnb_bedrooms: 5,
    airbnb_bathrooms: 4,
    main_cleaner: 'Joey Tribbiani',
    total_value: 500.0,
    cleaner_service_value: 300.0,
    is_active: true,
    is_deleted: false,
    created_by: 'd4e5f6g7-h8i9-0j1k-2l3m-4n5o6p7q8r9s',
    updated_by: 'd4e5f6g7-h8i9-0j1k-2l3m-4n5o6p7q8r9s',
    deleted_by: null,
    created_at: '1622808000',
    updated_at: '1622894400',
    deleted_at: null
  },
  {
    property_name: 'Seaside Escape',
    client_id: '101',
    number_of_rooms: '3',
    number_of_bathroom: '2',
    square_foot: '1500',
    other: 'Oceanfront view',
    zipcode: '94123',
    address: '123 Beach St',
    state: 'CA',
    city: 'San Francisco',
    location_lat: '37.80445833333333',
    location_long: '-122.451463333333333',
    get_in: '10:00 AM',
    get_in_instruction: 'Key under the mat',
    propertyICalLink: [
      {
        ical_label: 'Main Calendar',
        ical_link: 'https://example.com/ical1.ics'
      }
    ],
    property_image: ['https://picsum.photos/300', 'https://picsum.photos/200/300'],
    airbnb_listing_id: '12345',
    airbnb_bedrooms: 3,
    airbnb_bathrooms: 2,
    request_laundry: true,
    cleaning_on: 'Cleaning every week',
    propertyTasks: [
      { property_cleaning_task_id: null, task: 'Clean windows' },
      { property_cleaning_task_id: null, task: 'Check pantry supplies' },
      { property_cleaning_task_id: null, task: 'Clean BBQ grill' },
      { property_cleaning_task_id: null, task: 'Restock toiletries' }
    ],
    propertyConsumables: [{ property_cleaning_consumable_id: null, task: 'Restock coffee pods' }]
  },
  {
    property_name: 'Lakefront Villa',
    client_id: '105',
    number_of_rooms: '5',
    number_of_bathroom: '4',
    square_foot: '3500',
    other: 'Private dock',
    zipcode: '30305',
    address: '1010 Lakeview Rd',
    state: 'GA',
    city: 'Atlanta',
    location_lat: '33.7490',
    location_long: '-84.3880',
    get_in: '4:00 PM',
    get_in_instruction: 'Keypad entry',
    propertyICalLink: [
      {
        ical_label: 'Lakefront Rentals',
        ical_link: 'https://www.airbnb.com/calendar/ical/1086482103923631170.ics?s=88b6058a9287c7c64c6f756515d95ae9'
      }
    ],
    property_image: ['https://picsum.photos/300/300', 'https://picsum.photos/310/300'],
    airbnb_listing_id: '77889',
    airbnb_bedrooms: 5,
    airbnb_bathrooms: 4,
    request_laundry: true,
    cleaning_on: 'Cleaning after every guest',
    propertyTasks: [
      { task_id: 17, task: 'Check boat rentals' },
      { task_id: 18, task: 'Clean outdoor grill' },
      { task_id: 19, task: 'Clean pool area' },
      { task_id: 20, task: 'Restock firewood' }
    ],
    propertyConsumables: [{ task: 'Restock coffee supplies' }]
  },
  {
    property_name: 'Cozy Cottage',
    client_id: '104',
    number_of_rooms: '3',
    number_of_bathroom: '2',
    square_foot: '1400',
    other: 'Pet-friendly',
    zipcode: '90210',
    address: '789 Pine St',
    state: 'CA',
    city: 'Beverly Hills',
    location_lat: '34.0736',
    location_long: '-118.4004',
    get_in: '11:00 AM',
    get_in_instruction: 'Lockbox code sent by SMS',
    propertyICalLink: [
      {
        ical_label: 'Pet Friendly Stays',
        ical_link: 'https://example.com/ical4.ics'
      }
    ],
    property_image: ['https://picsum.photos/280', 'https://picsum.photos/280/300'],
    airbnb_listing_id: '11223',
    airbnb_bedrooms: 3,
    airbnb_bathrooms: 2,
    request_laundry: true,
    cleaning_on: 'Cleaning every 3 days',
    propertyTasks: [
      { task_id: 13, task: 'Restock pet supplies' },
      { task_id: 14, task: 'Clean backyard' },
      { task_id: 15, task: 'Vacuum carpets' },
      { task_id: 16, task: 'Mop the floors' }
    ],
    propertyConsumables: [{ task: 'Refill soap dispensers' }]
  },
  {
    property_name: 'Downtown Loft',
    client_id: '103',
    number_of_rooms: '2',
    number_of_bathroom: '1',
    square_foot: '1000',
    other: 'Rooftop access',
    zipcode: '10001',
    address: '456 Main St',
    state: 'NY',
    city: 'New York',
    location_lat: '40.7128',
    location_long: '-74.0060',
    get_in: '2:00 PM',
    get_in_instruction: 'Pick up key at the lobby',
    propertyICalLink: [
      {
        ical_label: 'Corporate Stays',
        ical_link: 'https://example.com/ical3.ics'
      }
    ],
    property_image: ['https://picsum.photos/250', 'https://picsum.photos/250/300'],
    airbnb_listing_id: '67890',
    airbnb_bedrooms: 2,
    airbnb_bathrooms: 1,
    request_laundry: true,
    cleaning_on: 'Cleaning on checkout',
    propertyTasks: [
      { task_id: 9, task: 'Check lighting fixtures' },
      { task_id: 10, task: 'Restock towels' },
      { task_id: 11, task: 'Clean rooftop area' },
      { task_id: 12, task: 'Replace linens' }
    ],
    propertyConsumables: [{ task: 'Restock bottled water' }]
  },
  {
    property_name: 'Mountain Cabin Retreat',
    client_id: '102',
    number_of_rooms: '4',
    number_of_bathroom: '3',
    square_foot: '2500',
    other: 'Near hiking trails',
    zipcode: '97035',
    address: '987 Hillside Dr',
    state: 'OR',
    city: 'Lake Oswego',
    location_lat: '45.4125',
    location_long: '-122.7209',
    get_in: '3:00 PM',
    get_in_instruction: 'Door code: 1234',
    propertyICalLink: [
      {
        property_cleaning_icallink_id: null,
        ical_label: 'Holiday Rentals',
        ical_link: 'https://www.airbnb.com/calendar/ical/1086482103923631170.ics?s=88b6058a9287c7c64c6f756515d95ae9'
      }
    ],
    property_image: ['https://picsum.photos/200', 'https://picsum.photos/250/250'],
    airbnb_listing_id: '54321',
    airbnb_bedrooms: 4,
    airbnb_bathrooms: 3,
    request_laundry: false,
    cleaning_on: 'Cleaning after every guest',
    propertyTasks: [
      { task_id: 5, task: 'Check fireplace' },
      { task_id: 6, task: 'Clean the hot tub' },
      { task_id: 7, task: 'Check wood supply' },
      { task_id: 8, task: 'Vacuum the carpets' }
    ],
    propertyConsumables: [{ task: 'Restock paper towels' }]
  },
  {
    property_name: 'Sunset Villa',
    client_id: '123456',
    number_of_rooms: '5',
    number_of_bathroom: '3',
    square_foot: '2500',
    other: 'Ocean view',
    zipcode: '90210',
    address: '123 Sunset Blvd, Beverly Hills, CA',
    state: 'California',
    city: 'Beverly Hills',
    location_lat: '34.090009',
    location_long: '-118.406498',
    get_in: 'Front door',
    get_in_instruction: 'Key under the mat',
    laundry_code: 'LAUN123',
    storage_area_code: 'STORE456',
    propertyICalLink: [
      {
        property_cleaning_icallink_id: 'ical-1',
        ical_label: 'Main Calendar',
        ical_link: 'https://example.com/calendar.ics'
      }
    ],
    property_image: ['https://example.com/image1.jpg', 'https://example.com/image2.jpg'],
    airbnb_listing_id: 'A1234567',
    airbnb_bedrooms: 5,
    airbnb_bathrooms: 3,
    request_laundry: true,
    cleaning_on: 'Cleaning on checkout',
    propertyTasks: [
      {
        property_cleaning_task_id: 'task-1',
        task: 'Vacuum the living room'
      },
      {
        property_cleaning_task_id: 'task-2',
        task: 'Clean the bathrooms'
      }
    ],
    propertyConsumables: [
      {
        property_cleaning_consumable_id: 'consumable-1',
        task: 'Restock toilet paper'
      },
      {
        property_cleaning_consumable_id: 'consumable-2',
        task: 'Replace towels'
      }
    ]
  }
]

export const defultPropertyValues = {
  property_name: '',
  client_id: '',
  number_of_rooms: '',
  number_of_bathroom: '',
  square_foot: '',
  other: '',
  zipcode: '',
  address: '',
  state: '',
  city: '',
  location_lat: '',
  location_long: '',
  get_in: '',
  get_in_instruction: '',
  laundry_code: '',
  storage_area_code: '',
  propertyICalLink: [
    {
      property_cleaning_icallink_id: null,
      ical_label: '',
      ical_link: ''
    }
  ],
  property_image: [
    // 'https://picsum.photos/300',
    // 'https://picsum.photos/200/300/?blurr',
    // 'https://picsum.photos/200',
    // 'https://picsum.photos/200/200/?blur'
  ],
  airbnb_listing_id: null,
  airbnb_bedrooms: null,
  airbnb_bathrooms: null,
  request_laundry: false,
  cleaning_on: 'Cleaning on checkout',
  propertyTasks: [
    { property_cleaning_task_id: null, task: '' }
    // { property_cleaning_task_id: null, task: 'Refill coffee and soda/water' }
    // { property_cleaning_task_id: null, task: 'Change throw blanket' },
    // { property_cleaning_task_id: null, task: 'Check toilet refills' },
    // { property_cleaning_task_id: null, task: 'Mop the floor every time' }
  ],
  propertyConsumables: [
    { property_cleaning_consumable_id: null, task: '' }
    // { property_cleaning_consumable_id: null, task: 'Mop the floor every time' }
  ]
}
export const dummyChatApp = [
  {
    id: 1,
    sender: true,
    message: 'Hello 👋',
    created_at: '1728037062',
    created_by_client: true
  },
  {
    id: 2,
    sender: true,
    message: 'Can you start with the living room—vacuum, dust, and windows?',
    created_at: '1728037062',
    created_by_client: true
  },
  {
    id: 3,
    sender: false,
    message: 'Sure, and then the kitchen—countertops and stove?',
    created_at: '1728037062',
    created_by_client: true
  },
  {
    id: 4,
    sender: true,
    message: 'Yes, and the bathroom—sink, toilet, shower, and floor.',
    created_at: '1728037062',
    created_by_client: false
  },
  {
    id: 5,
    sender: false,
    message: 'Got it. Bedrooms too?',
    created_at: '1728037062',
    created_by_client: false
  },
  {
    id: 6,
    sender: true,
    message: 'Just make the beds and a quick dust.',
    created_at: '1728037062',
    created_by_client: false
  },
  {
    id: 6,
    sender: false,
    message: 'Will do. I’ll get started! 👍',
    created_at: '1728037062',
    created_by_client: false
  },
  {
    id: 6,
    sender: true,
    message: 'Thanks!',
    created_at: '1728037062',
    created_by_client: false
  }
]
export const BILLINGS_DATA = [
  {
    id: 1,
    date: '2024-10-01',
    property: 'Property A',
    cleaner: 'John Doe',
    payment_status: 'paid',
    payment: 150.0
  },
  {
    id: 2,
    date: '2024-10-02',
    property: 'Property B',
    cleaner: 'Jane Smith',
    payment_status: 'pending',
    payment: 200.0
  },
  {
    id: 3,
    date: '2024-10-03',
    property: 'Property C',
    cleaner: 'Emily Johnson',
    payment_status: 'paid',
    payment: 175.0
  },
  {
    id: 4,
    date: '2024-10-04',
    property: 'Property D',
    cleaner: 'Michael Brown',
    payment_status: 'failed',
    payment: 225.0
  },
  {
    id: 5,
    date: '2024-10-05',
    property: 'Property E',
    cleaner: 'Sarah Davis',
    payment_status: 'paid',
    payment: 130.0
  },
  {
    id: 6,
    date: '2024-10-06',
    property: 'Property F',
    cleaner: 'David Wilson',
    payment_status: 'pending',
    payment: 190.0
  },
  {
    id: 7,
    date: '2024-10-07',
    property: 'Property G',
    cleaner: 'Mary Garcia',
    payment_status: 'paid',
    payment: 220.0
  },
  {
    id: 8,
    date: '2024-10-08',
    property: 'Property H',
    cleaner: 'Chris Martinez',
    payment_status: 'failed',
    payment: 210.0
  },
  {
    id: 9,
    date: '2024-10-09',
    property: 'Property I',
    cleaner: 'Daniel Anderson',
    payment_status: 'paid',
    payment: 180.0
  },
  {
    id: 10,
    date: '2024-10-10',
    property: 'Property J',
    cleaner: 'Patricia Thomas',
    payment_status: 'pending',
    payment: 160.0
  },
  {
    id: 11,
    date: '2024-10-11',
    property: 'Property K',
    cleaner: 'Jessica Lee',
    payment_status: 'paid',
    payment: 170.0
  },
  {
    id: 12,
    date: '2024-10-12',
    property: 'Property L',
    cleaner: 'Andrew Hernandez',
    payment_status: 'failed',
    payment: 145.0
  },
  {
    id: 13,
    date: '2024-10-13',
    property: 'Property M',
    cleaner: 'Angela Miller',
    payment_status: 'paid',
    payment: 240.0
  },
  {
    id: 14,
    date: '2024-10-14',
    property: 'Property N',
    cleaner: 'Matthew King',
    payment_status: 'pending',
    payment: 195.0
  },
  {
    id: 15,
    date: '2024-10-15',
    property: 'Property O',
    cleaner: 'Barbara Moore',
    payment_status: 'paid',
    payment: 210.0
  },
  {
    id: 16,
    date: '2024-10-16',
    property: 'Property P',
    cleaner: 'Richard Harris',
    payment_status: 'failed',
    payment: 185.0
  }
]

export const IMAGE_MODULE = {
  CLIENT: 'client',
  CLEANER: 'cleaner',
  ADMIN: 'admin',
  PROPERTIES: 'properties',
  CLEANING_COMPLETE: 'cleaning_complete',
  CLEANING_REPORTS: 'cleaning_reports'
}

export const NoFoundText = {
  PROPERTIES: 'Property Not Available',
  REVIEW_PENNDING: 'Review Not Available',
  REVIEW_COMPLETE: 'Reviewed Not Available',
  NOTIFICATIONS: 'Notification Not Available'
}
